/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BlockerCategoryEnum = {
    Absence: 'ABSENCE',
    InternalAppointment: 'INTERNAL_APPOINTMENT'
} as const;
export type BlockerCategoryEnum = typeof BlockerCategoryEnum[keyof typeof BlockerCategoryEnum];

